import { useMutation } from "@tanstack/react-query";
import { API_ENDPOINTS } from "../../../helpers/constants";
import apiInstance from "../../instances/apiInstance";
import {
  ReferenceDataRequest,
  ReferenceDataResponse,
  ReferenceAnswer,
} from "./models";

export const useFetchReferenceDataMutation = () => {
  return useMutation({
    mutationFn: async (params: { ids: string[]; locale: string }) => {
      if (!params.ids || params.ids.length === 0) {
        return [];
      }

      const payload: ReferenceDataRequest = {
        locale: [params.locale],
        key: [],
        id: params.ids,
      };

      const response = await apiInstance.post<ReferenceDataResponse[]>(
        API_ENDPOINTS.REFERENCE_DATA_SEARCH,
        payload,
      );

      return transformReferenceResponse(response.data);
    },
  });
};

const transformReferenceResponse = (
  data: ReferenceDataResponse[],
): ReferenceAnswer[] => {
  const answers: ReferenceAnswer[] = [];

  data.forEach((category) => {
    category.items.forEach((item) => {
      answers.push({
        AnswerId: item.id,
        AnswerText: item.title,
        ItemID: item.id,
        ResultPageTitle: null,
        IsQuestionTitleAppended: false,
        key: item.key,
        idSource: item.idSource,
      });
    });
  });

  return answers;
};
